import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import Rating from 'marketplace-ui-reviews/components/Rating';
import * as ThemeQueryField from 'marketplace-ui-assets-core/constants/ThemeQueryField';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import { jsx as _jsx } from "react/jsx-runtime";
const ALL_RATINGS_VALUE = '__ALL_RATINGS__';
const RatingFilterOptionLabel = ({
  option
}) => {
  const rating = option.value;
  if (rating === ALL_RATINGS_VALUE) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.assets.filters.rating.allOptionLabel"
    });
  }
  return /*#__PURE__*/_jsx(Rating, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.assets.filters.rating.optionLabel"
    }),
    rating: rating,
    iconSize: "xxs"
  });
};
let cachedOptions;
const getOptions = () => {
  if (!cachedOptions) {
    cachedOptions = [{
      value: ALL_RATINGS_VALUE,
      text: unescapedText('marketplace-assets-ui.assets.filters.rating.text.all')
    }, {
      value: 4,
      text: unescapedText('marketplace-assets-ui.assets.filters.rating.text.fourAndUp')
    }, {
      value: 3,
      text: unescapedText('marketplace-assets-ui.assets.filters.rating.text.threeAndUp')
    }, {
      value: 2,
      text: unescapedText('marketplace-assets-ui.assets.filters.rating.text.twoAndUp')
    }, {
      value: 1,
      text: unescapedText('marketplace-assets-ui.assets.filters.rating.text.oneAndUp')
    }];
  }
  return cachedOptions;
};
const RatingFilter = ({
  disabled,
  name,
  onChange,
  value
}) => {
  const handleOnChange = useCallback(event => {
    const eventValue = event.target.value;
    const newValue = eventValue === ALL_RATINGS_VALUE ? null : eventValue;
    onChange(ThemeQueryField.MIN_OVERALL_RATING, newValue);
  }, [onChange]);
  return /*#__PURE__*/_jsx(FilterToggleGroup, {
    ariaLabel: unescapedText('marketplace-assets-ui.assets.filters.rating.title'),
    disabled: disabled,
    labelComponent: RatingFilterOptionLabel,
    multi: false,
    name: name || ThemeQueryField.MIN_OVERALL_RATING,
    onChange: handleOnChange,
    options: getOptions(),
    value: value || ALL_RATINGS_VALUE
  });
};
export default RatingFilter;